module.exports = __webpack_public_path__ + "static/media/vietcombank.84af05b5.png";